import { useEffect } from 'react';
import {
    applyNexusThemeFromPreference,
    resolveNexusTheme,
    applyNexusThemeToDocument,
} from '../lib/nexusTheme';
import { useLayoutPreferences } from './useLayoutPreferences';

/**
 * Sincroniza `data-theme` no shell com a preferência salva e reage ao SO
 * quando `theme === 'system'`.
 */
export function useSyncNexusTheme(): void {
    const { theme } = useLayoutPreferences();

    useEffect(() => {
        applyNexusThemeFromPreference(theme);
    }, [theme]);

    useEffect(() => {
        if (theme !== 'system' || typeof window === 'undefined') {
            return;
        }

        const media = window.matchMedia('(prefers-color-scheme: dark)');

        const syncFromOs = () => {
            applyNexusThemeToDocument(resolveNexusTheme('system'));
        };

        syncFromOs();
        media.addEventListener('change', syncFromOs);

        return () => {
            media.removeEventListener('change', syncFromOs);
        };
    }, [theme]);
}
